import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../../domain/models/report_data";
import { IGetReportContratoFinanceiroIndividualUseCase } from "../../../presentation/useCases/read/get_report_contrato_financeiro_individual_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportContratoFinanceiroIndividualUseCase
 */

export class GetReportContratoFinanceiroIndividualUseCase implements IGetReportContratoFinanceiroIndividualUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportContratoFinanceiroIndividual(idContratoFinanceiro: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportContratoFinanceiroIndividual(idContratoFinanceiro, requiredMimeType);

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `contrato_financeiro_individual_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
